import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import {
    Typography,
    Button,
    DialogContent,
    DialogActions,
    Dialog,
} from '@mui/material'
import { useTranslation } from 'shared/hooks/useSafeTranslation'
import useStyles from 'shared/hooks/useStyle'
import getGlobalAssetUrl from 'shared/utils/getGlobalAssetUrl'

import styles from './ScanErrorDialog.style'

const propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    item: PropTypes.shape({ number: PropTypes.string.isRequired }),
}

const ScanErrorDialog = ({
    onClose,
    open,
    item = null,
}) => {
    const classes = useStyles(styles)
    const { t } = useTranslation()
    const handleCancel = () => {
        onClose()
    }

    const errorMessage = useMemo(() => {
        if (!item) return ''

        return t('WRONG_CONTAINER', { serialNumber: item.number })
    }, [
        item,
        t,
    ])

    return (
        <Dialog
            id="barcode-scan-error-dialog"
            keepMounted
            fullWidth
            maxWidth="sm"
            aria-labelledby="barcode-scan-error-dialog"
            open={open}
            css={classes.dialogRoot}
        >
            <DialogContent css={classes.dialogContentRoot}>
                <img
                    alt="logo"
                    src={getGlobalAssetUrl('icons/warning.svg')}
                    css={classes.icon}
                />
                <Typography
                    variant="h3"
                >
                    {errorMessage}
                </Typography>
            </DialogContent>
            <DialogActions
                css={classes.dialogActionsRoot}
            >
                <Button
                    data-testid="ok-button"
                    css={classes.button}
                    onClick={handleCancel}
                >
                    {t('OK')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

ScanErrorDialog.propTypes = propTypes

export default ScanErrorDialog
